import React from 'react';
import stylesheet from './ListItem.module.scss';

const ListItem = props => {
    const {className = '', tagName: Tag = 'li', children,unpadded, ...otherProps} = props;

    return (
        <Tag className={[stylesheet.ListItem, className, unpadded ? stylesheet.unpadded : ''].join(' ')} {...otherProps}>
            {children}
        </Tag>
    );
};

export default ListItem;
